import * as RadixCheckbox from "@radix-ui/react-checkbox";
import clsx from "clsx";
import React, { forwardRef } from "react";

export const CheckboxButton = forwardRef<
  React.ElementRef<typeof RadixCheckbox.Root>,
  React.ComponentPropsWithoutRef<typeof RadixCheckbox.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadixCheckbox.Root ref={ref} className={clsx(className)} {...props} />
  );
});

CheckboxButton.displayName = "CheckboxButton";
